// @flow

import * as React from 'react';

import classNames from '@ta/common.classnames';
import { ResponsiveImage } from '@ta/media.image';
import { Opener } from '@ta/overlays.managers';
import { Link } from '@ta/common.routing';

import styles from './SectionThumbnails.less';

type Props = {|
  member: any,
  actor: any,
  object: any,
  getLinkForImage?: (image: any) => ?string,
  onClick?: (SyntheticMouseEvent<HTMLElement>) => mixed,
  className?: string,
|};

const SectionThumbnails = ({ object, getLinkForImage, onClick, className }: Props) => {
  const MAX = 3;
  const thumbnails = object.object.photos;
  const remainingCount = thumbnails && thumbnails.length - MAX;

  let gridType = '';

  if (!thumbnails || thumbnails.length === 0) {
    return null;
  }

  if (thumbnails) {
    switch (thumbnails.length) {
      case 1:
        gridType = classNames(styles.flex_item, styles.use1x1);
        break;
      case 2:
        gridType = classNames(styles.flex_item, styles.use2x1);
        break;
      default:
        gridType = classNames(styles.flex_item, styles.use3x1);
    }
  }

  return (
    <div className={classNames(styles.flex_grid, className)}>
      {thumbnails &&
        thumbnails
          .filter(thumb => !!thumb)
          .slice(0, MAX)
          .map((thumbnail, index) => {
            const inner = (
              <React.Fragment>
                {index === MAX - 1 && remainingCount > 0 && (
                  <span className={styles.hasCTA}>+{remainingCount}</span>
                )}
                <ResponsiveImage sources={thumbnail.photoSizes} width="100%" height="128px" />
              </React.Fragment>
            );

            if (getLinkForImage) {
              const link = getLinkForImage(thumbnail);
              if (link) {
                return (
                  <div key={thumbnail.id || index} className={gridType}>
                    <Link href={link} onClick={onClick}>
                      {inner}
                    </Link>
                  </div>
                );
              }
            }
            return (
              <React.Fragment key={thumbnail.id || index}>
                <Opener name={`view_${thumbnail.id}`}>
                  {open => (
                    <div className={gridType} onClick={open}>
                      {inner}
                    </div>
                  )}
                </Opener>
              </React.Fragment>
            );
          })}
    </div>
  );
};

SectionThumbnails.defaultProps = {
  getLinkForImage: undefined,
  onClick: undefined,
  className: undefined,
};

export default SectionThumbnails;
